import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../../utils/const";
import styles from "../InternalTracker.module.css";
import { Box, Typography } from "@mui/material";
import { height } from "@mui/system";

function SendRequirementDrawer({
  handleClose,
  show,
  selectedCandidate,
  handleShowDwaer,
  setHotListRow,
}) {
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="bottom"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        // marginTop: "74px",
        width: "100%",
        height: "15%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header> */}
      <Offcanvas.Body style={{ padding: "0", marginTop: "20px" }}>
        <Box
          className={styles.internal_update_btns}
          sx={{ padding: "2px 20px !important", margin: "0 !important" }}
        >
          <Box sx={{ position: "relative", left: "250px" }}>
            <span>
              <Typography>
                You have selected {selectedCandidate?.length} candidates from
                the filter
              </Typography>
              <Typography>
                <b> Note: Max 50 send limit in one short.</b>
              </Typography>
            </span>
          </Box>
          <Box>
            <button
              style={
                selectedCandidate?.length === 0
                  ? {
                      backgroundColor: "#3856a6",
                      padding: "7.5px 15px",
                      cursor: "not-allowed",
                    }
                  : { backgroundColor: "#3856a6", padding: "7.5px 15px" }
              }
              onClick={() => {
                handleShowDwaer();
                setHotListRow(selectedCandidate);
              }}
              disabled={selectedCandidate?.length === 0}
            >
              Send Requirement
            </button>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SendRequirementDrawer;
